import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchRentalDeliveryPlanning(action) {
  const {date} = action.params;
  try {
    const planning = yield call(() => Api.get('/dealer/delivery-planning', {date}));
    yield put({type: 'FETCH_RENTAL_DELIVERY_PLANNING.SUCCESS', planning})
  } catch (error) {
    yield put({type: 'FETCH_RENTAL_DELIVERY_PLANNING.FAILURE'})
  }
}

function* fetchRentalReporting(action) {
  const {rentalDetailsId} = action;
  try {
    const reporting = yield call(function() {
      return Api.get(`/rental-details/${rentalDetailsId}/reporting`);
    });
    yield put({type: 'FETCH_RENTAL_REPORTING.SUCCESS', reporting});
  } catch (error) {
    yield put({type: 'FETCH_RENTAL_REPORTING.FAILURE', error});
  }
}

function* deliverRentalVehicle(action) {
  const {rentalDetailsId, body} = action;
  try {
    const report = yield call(function() {
      return Api.post(`/rental-details/${rentalDetailsId}/deliver`, body);
    });
    yield put({type: 'DELIVER_RENTAL_VEHICLE.SUCCESS', report});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'HIDE_DELIVERY_MODAL'});
    yield put({type: 'FETCH_RENTAL_REPORTING.REQUEST', rentalDetailsId})
  } catch (error) {
    yield put({type: 'DELIVER_RENTAL_VEHICLE.FAILURE', error});
  }
}

function* returnRentalVehicle(action) {
  const {rentalDetailsId, body} = action;
  try {
    const report = yield call(function() {
      return Api.post(`/rental-details/${rentalDetailsId}/return`, body);
    });
    yield put({type: 'RETURN_RENTAL_VEHICLE.SUCCESS', report});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'HIDE_DELIVERY_MODAL'});
    yield put({type: 'FETCH_RENTAL_REPORTING.REQUEST', rentalDetailsId})
  } catch (error) {
    yield put({type: 'RETURN_RENTAL_VEHICLE.FAILURE', error});
  }
}

export function* watchFetchRentalDeliveryPlanning() {
  yield takeEvery('FETCH_RENTAL_DELIVERY_PLANNING.REQUEST', fetchRentalDeliveryPlanning);
}

export function* watchFetchRentalReporting() {
  yield takeEvery('FETCH_RENTAL_REPORTING.REQUEST', fetchRentalReporting)
}

export function* watchDeliverRentalVehicle() {
  yield takeEvery('DELIVER_RENTAL_VEHICLE.REQUEST', deliverRentalVehicle)
}

export function* watchReturnRentalVehicle() {
  yield takeEvery('RETURN_RENTAL_VEHICLE.REQUEST', returnRentalVehicle)
}



// WEBPACK FOOTER //
// ./src/sagas/rentalReporting.js